import React, { Component, ErrorInfo, ReactNode } from "react";
import { Alert, Button, Container, Typography } from "@mui/material";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Unhandled error:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <Container maxWidth="sm" style={{ marginTop: "4rem" }}>
          <Alert severity="error" style={{ marginBottom: "1rem" }}>
            <Typography variant="h6">Something went wrong</Typography>
            <Typography variant="body2">An unexpected error occurred. Please try reloading the page.</Typography>
          </Alert>
          <Button variant="outlined" onClick={() => window.location.reload()}>
            Reload page
          </Button>
        </Container>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
